import React from 'react';
import { Provider } from 'react-redux';
import configureStore from './redux';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import handleCache from './collums-components/helpers/handleCache';

ReactDOM.render(
    <Provider store={configureStore()}>
        <App />
    </Provider>,
    document.getElementById('root')
);

handleCache();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then(regs => Promise.all(regs.map(reg => reg.unregister())))
        .then(() => (typeof caches !== 'undefined' ? caches.keys() : []))
        .then(keys => Promise.all(keys.map(k => caches.delete(k))))
        .catch(() => {});
}
